import { Component } from 'react'
import store from '../../store'

class FlowView extends Component {
  constructor (props, title) {
    super(props)
    store.dispatch({type: 'SET_NAVIGATION_PROPS', payload: this.props.match})
    if (!title) return
    store.dispatch({type: 'SET_PAGE_TITLE', payload: title})
  }
}

export default FlowView



// WEBPACK FOOTER //
// ./src/components/core/FlowView.js